module.exports = __webpack_public_path__ + "img/red_trash_icon.ff45010b.svg";